export class ListGoogleWorkspacesWithPolicyStatusResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workspaces",
            "baseName": "workspaces",
            "type": "Array<GoogleWorkspaceWithPolicyStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspacesWithPolicyStatusResponse.attributeTypeMap;
    }
    constructor() {
    }
}
